import React from 'react';
import PropTypes from 'prop-types';
import Form from '../Common/Form.react';
import TextField from '../Common/TextField';
import SelectField from '../Common/SelectField';
import MenuItem from 'material-ui/MenuItem';

import { Card, CardText } from 'material-ui/Card';

const getTemplateField = (templates, value = null) => {
    if (!templates || !templates.length) { return false; }

    let selectFieldProps = {
        name: "templateId",
        hintText: "Template",
        floatingLabelText: "Template",
        children: templates.map(({id, name}) => <MenuItem key={id} value={id} primaryText={name} />),
        value,
        required: true
    };
    if (!selectFieldProps.value) {
        let defaultTemplate = templates.find((t) => (t !== undefined && !!t.default) );
        if (defaultTemplate) {
            selectFieldProps.value = defaultTemplate.id;
        }
    }
    return (<SelectField {...selectFieldProps} />);
};

const ReminderForm = ({reminder, templates, ...props}) => {
    const formTitle = (props.title ? props.title : "New Reminder");
    const returnUrl = props.returnUrl;


    const templateField = getTemplateField(templates, reminder.templateId);
    const onCancel = () => (window.location.href = props.returnUrl);
    const onSubmit = (formData) => props.onSubmit(formData);


    return (

        <Form
            title={formTitle}
            onSave={onSubmit}
            onCancel={onCancel}
            redirectTo={returnUrl}
        >
            <Card className="cent-card">
                <CardText>
                    <div className='cent-flex-row'>
                        <div className='cent-col-2'>
                            <SelectField
                                name="unit"
                                hintText="Unit"
                                floatingLabelText="Unit"
                                value={reminder.unit}
                                required
                            >
                                {props.units.map((unit, index) => <MenuItem key={index} value={unit} primaryText={unit} />)}
                            </SelectField>
                        </div>
                        <div className='cent-col-2'>
                            <TextField
                                name="number"
                                hintText="Value"
                                floatingLabelText="Value"
                                value={reminder.number}
                                required
                            />
                        </div>
                        <div className='cent-col-1'>
                            {templateField}
                        </div>
                        <div className='cent-col-1'>
                            <TextField
                                name="textBody"
                                hintText="Body"
                                floatingLabelText="Body"
                                value={reminder.textBody}
                                disabled={!!reminder.id}
                            />
                        </div>
                        <div className='cent-col-1'>
                            <SelectField
                                name="type"
                                hintText="Type"
                                floatingLabelText="Type"
                                value={reminder.type}
                                disabled={!!reminder.id}
                                required
                            >
                            {props.types.map((type, index) => <MenuItem key={index} value={type} primaryText={type} />)}
                            </SelectField>
                        </div>
                    </div>
                </CardText>
            </Card>
        </Form>
    );
};



ReminderForm.propTypes = {
    title: PropTypes.string,
    returnUrl: PropTypes.string.isRequired,
    templates: PropTypes.array,
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func,

    reminder: PropTypes.shape({
        body: PropTypes.string,
        number: PropTypes.number,
        unit: PropTypes.string,
        type: PropTypes.string,
        templateId: PropTypes.number
    })
};

ReminderForm.defaultProps = {
    templates: [],
    units: ['minutes', 'hours', 'days'],
    types: ['email', 'notification'],
    reminder: {
        body: '',
        number: null,
        unit: 'hours',
        type: 'email',
        template: null
    }
};

export default ReminderForm;
